document.addEventListener("turbo:load", function () {
  let elms = document.querySelectorAll(".mouse-cursor-gradient-tracking");
  if (!elms) return;
  elms.forEach(function (elm) {
    elm.onmousemove = function (e) {
      let rect = e.target.getBoundingClientRect();
      let width = rect.width;
      let height = rect.height;
      let x = e.clientX - rect.left;
      let xPercentage = Math.round((x / width) * 100);
      let y = e.clientY - rect.top;
      let yPercentage = Math.round((y / height) * 100);
      elm.style.setProperty("--mouse-x", x + "px");
      elm.style.setProperty("--mouse-percentage-x", xPercentage);
      elm.style.setProperty("--mouse-y", y + "px");
      elm.style.setProperty("--mouse-percentage-y", yPercentage);
    };
  });
});
